import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Importação de bibliotecas externas
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';

//Criando a aplicação Vue
const app = createApp(App);

//Criando propriedades globais
app.config.globalProperties.$http                = axios;
app.config.globalProperties.$servidorRota        = "https://grupo-colab.tech:8000/";
//app.config.globalProperties.$servidorRota        = "https://grupo-colab.tech/controller/";

//Utilizando o router
app.use(router);

//Montando a aplicação
app.mount('#app');
